import React, { useState } from "react";
import { Button, Snackbar, Alert, CircularProgress } from "@mui/material";

export default function SendVerificationEmails() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleSendEmails = async () => {
    if (
      !window.confirm(
        "This will send verification emails to all unverified users. Continue?",
      )
    ) {
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/users/send-verification-emails`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to send emails");
      }

      setSuccess(
        `Emails sent successfully. Sent: ${data.sent}, Failed: ${data.failed}`,
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSendEmails}
        disabled={loading}
        sx={{ minWidth: 220, backgroundColor: "var(--primary-color)" }}
      >
        {loading ? (
          <CircularProgress size={22} color="inherit" />
        ) : (
          "Send Email Verification"
        )}
      </Button>

      {/* Success Snackbar */}
      <Snackbar
        open={Boolean(success)}
        autoHideDuration={6000}
        onClose={() => setSuccess(null)}
      >
        <Alert severity="success" onClose={() => setSuccess(null)}>
          {success}
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={Boolean(error)}
        autoHideDuration={6000}
        onClose={() => setError(null)}
      >
        <Alert severity="error" onClose={() => setError(null)}>
          {error}
        </Alert>
      </Snackbar>
    </>
  );
}
